"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./setPublicPath");
var Loadable = require("react-loadable");
var compile_1 = require("./compile");
function client() {
    var config = window.__CONFIG__;
    delete window.__CONFIG__;
    return Loadable.preloadReady().then(function () {
        return { config: config, compile: compile_1.compile };
    });
}
exports.client = client;
//# sourceMappingURL=index.js.map